import { GridLocation } from "src/grid/GridLocation";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class ManaFocusInstruction extends Instruction<"mana-focus"> {
  readonly type = "mana-focus";

  act(context: ProgramModel) {
    const neighbors = context.getNeighboringInstructions(
      context.cursorGridLocation
    );
    const manaCount = neighbors.reduce((count, neighbor) => {
      if (neighbor.type === "mana") return count + 1;
      return count;
    }, 0);
    context.mana += manaCount;
  }
}
